<template>
  <div id="app">
    <EbBanner :isActive="isIE" type="warning" position="ieDisclaimer" :displayCloseButton="false">L'affichage de cette interface d'administration <strong>n'est pas compatible avec le navigateur Internet Explorer</strong>.<br />Nous vous invitons à utiliser Chrome, Firefox ou Edge.</EbBanner>
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
  const default_layout = "Dashboard",
  isIE = /*@cc_on!@*/false || !!document.documentMode
  
  export default {
    computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + '-layout'
      },
      isIE() {
        return isIE
      }
    }
  }
</script>

<style lang="scss">
@import url(assets/css/knacss-temp.min.css);
//@import "@/ecobods/styles/knacss-config/knacss";

:root {
  @include defineColorHSL(--color-site-primary, 347, 40%, 52%); // #B55368;
  @include defineColorHSL(--color-site-secondary, 345, 44%, 46%); // #A8415A
}

html {
  @include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min, $fontSize-max);
}

body {
  font-size: 1rem;
  margin: 0 auto;
  font-family: $eb-font-family-default;
  color: $eb-color-gray-700;
}

</style>
